import i18nLocale from "@/helpers/locale";

/**
 * menu item show in side menu condiations:
 * has "groupTitle"
 */

/**
 * User Roles:
 * ["superAdmin", "brand", "cinema"]
 * ========== NOTICE ==========
 * 1. After edit the subpage "accessRight", please confirm parent page's "accessRight" too.
 * 2. menuMapping key "name" must a unique value, it will be using to build a SideMenu component.
 */

const menuMapping = [
  {
    name: "landing",
    path: "/",
    redirect: "/login",
    accessRight: ["superAdmin", "brand", "cinema"],
    isAuth: false,
  },
  {
    name: "login",
    path: "/login",
    component: () => import(/* webpackChunkName: "Login" */ "@/pages/Login/Login"),
    accessRight: ["superAdmin", "brand", "cinema"],
    isAuth: false,
  },
  {
    name: "help",
    path: "/help",
    component: () => import(/* webpackChunkName: "Help" */ "@/pages/Help/Help"),
    accessRight: ["superAdmin", "brand", "cinema"],
    isAuth: false,
  },
  {
    name: "notification",
    path: "/notification-details",
    component: () => import(/* webpackChunkName: "Notification" */ "@/pages/Notification"),
    accessRight: ["superAdmin", "brand", "cinema"],
    isAuth: true,
  },
  {
    name: "dashboard",
    component: () => import(/* webpackChunkName: "Dashboard" */ "@/pages/Dashboard/Dashboard"),
    accessRight: ["superAdmin", "brand", "cinema"],
    groupTitle: i18nLocale("sideMenu.dashboard"),
    icon: "el-icon-odometer",
    path: "/dashboard",
    permission: "Dashboard",
    props: { module: "dashboard" },
    item: [],
  },
  {
    name: "film",
    accessRight: ["superAdmin", "brand", "cinema"],
    groupTitle: i18nLocale("sideMenu.film"),
    icon: "el-icon-film",
    path: "",
    permission: "Film",
    item: [
      {
        name: "movieList",
        component: () => import(/* webpackChunkName: "Movie" */ "@/pages/Movie/Movie"),
        accessRight: ["superAdmin", "brand", "cinema"],
        groupTitle: i18nLocale("sideMenu.film.library"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/movie",
        permission: "Film library",
        props: { module: "film_library" },
      },
      {
        name: "movieCreate",
        component: () => import(/* webpackChunkName: "MovieDetail" */ "@/pages/Movie/MovieDetail"),
        accessRight: ["superAdmin", "brand", "cinema"],
        path: "/movie/create",
        permission: "Film library create",
        props: { module: "film_library" },
      },
      {
        name: "movieDetail",
        component: () => import(/* webpackChunkName: "MovieDetail" */ "@/pages/Movie/MovieDetail"),
        accessRight: ["superAdmin", "brand", "cinema"],
        path: "/movie/update/:id",
        permission: "Film library update",
        props: { module: "film_library" },
      },
      {
        name: "restrict",
        component: () => import(/* webpackChunkName: "Restrict" */ "@/pages/Restrict/Restrict"),
        accessRight: [ "cinema" ],
        groupTitle: i18nLocale("sideMenu.film.classification"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/restrict",
        permission: "Film Classifiion and Rating",
        props: { module: "ethical" },
      },
      {
        name: "moviTicketMaster",
        component: () => import(/* webpackChunkName: "MoviTicketMaster" */ "@/pages/Movie/MoviTicketMaster"),
        accessRight: ["superAdmin", "brand", "cinema"],
        groupTitle: i18nLocale("sideMenu.film.moviTicketMaster"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/movie-ticket-master",
        permission: "moviTicketMaster",
        props: { module: "film_library" },
      }
    ],
  },
  {
    name: "performance",
    accessRight: [ "cinema" ],
    groupTitle: i18nLocale("sideMenu.performance"),
    icon: "el-icon-date",
    path: "",
    permission: "Performance",
    item: [
      {
        name: "schedule",
        component: () => import(/* webpackChunkName: "Schedule" */ "@/pages/Schedule/Schedule"),
        accessRight: [ "cinema" ],
        groupTitle: i18nLocale("sideMenu.performance.schedule"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/schedule",
        permission: "Scheduling",
        props: { module: "scheduling" },
      },
      // {
      //   name: "scheduleCreate",
      //   component: () => import(/* webpackChunkName: "ScheduleDetail" */ "@/pages/Schedule/ScheduleDetail"),
      //   path: "/schedule/create",
      //   props: { module: "scheduling" },
      // },
      {
        name: "scheduleCreate",
        component: () => import(/* webpackChunkName: "ScheduleDetail" */ "@/pages/Schedule/ScheduleAdd"),
        path: "/schedule/create",
        props: { module: "scheduling" },
      },
      {
        name: "scheduleEdit",
        component: () => import(/* webpackChunkName: "ScheduleDetail" */ "@/pages/Schedule/ScheduleDetail"),
        path: "/schedule/edit/:id",
        props: { module: "scheduling" },
      },
      {
        name: "rules",
        component: () => import(/* webpackChunkName: "rules" */ "@/pages/RuleTemplate/rules"),
        accessRight: [ "cinema" ],
        groupTitle: i18nLocale("sideMenu.performance.priceRuleTemplate"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/rules",
        permission: "Price Rule template",
        props: { module: "rules_template" },
      },
      {
        name: "rulesCreate",
        component: () => import(/* webpackChunkName: "RuleTemplateDetail" */ "@/pages/RuleTemplate/RuleTemplateDetail"),
        path: "/rules/create",
        props: { module: "rules_template" },
      },
      {
        name: "rulesEdit",
        component: () => import(/* webpackChunkName: "RuleTemplateDetail" */ "@/pages/RuleTemplate/RuleTemplateDetail"),
        path: "/rules/edit/:id",
        props: { module: "rules_template" },
      },
      {
        name: "discountRules",
        component: () => import(/* webpackChunkName: "DiscountRules" */ "@/pages/DiscountRuleTemplate/rules"),
        accessRight: [ "cinema" ],
        groupTitle: i18nLocale("sideMenu.performance.discountRuleTemplate"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/discountRules",
        permission: "discount Rule template",
        props: { module: "discountRules_template" },
      },
      {
        name: "discountRulesCreate",
        component: () => import(/* webpackChunkName: "DisCountRuleTemplateDetail" */ "@/pages/DiscountRuleTemplate/DiscountRuleTemplateDetail"),
        path: "/disCountRules/create",
        props: { module: "discountRules_template" },
      },
      {
        name: "discountRulesEdit",
        component: () => import(/* webpackChunkName: "DisCountRuleTemplateDetail" */ "@/pages/DiscountRuleTemplate/DiscountRuleTemplateDetail"),
        path: "/disCountRules/edit/:id",
        props: { module: "discountRules_template" },
      },
      {
        name: "versionManagement",
        component: () => import(/* webpackChunkName: "Version" */ "@/pages/Version/Version"),
        accessRight: [ "cinema" ],
        groupTitle: i18nLocale("sideMenu.performance.version1"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/version-management",
        permission: "Version 1 (Master)",
        props: { module: "version" },
      },
      {
        name: "versionManagementOther",
        component: () => import(/* webpackChunkName: "VersionOther" */ "@/pages/Version/VersionOther"),
        accessRight: [ "cinema" ],
        groupTitle: i18nLocale("global.otherVersions"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/version-other",
        permission: "Version 3 (Master)",
        props: { module: "other_version" },
      }
    ],
  },
  {
    name: "shop",
    accessRight: ["brand", "cinema"],
    groupTitle: i18nLocale("sideMenu.shop"),
    icon: "el-icon-shopping-bag-1",
    path: "",
    permission: "Shop",
    item: [
      {
        name: "concession",
        component: () => import(/* webpackChunkName: "Concession" */ "@/pages/Concession/Concession"),
        accessRight: [ "cinema" ],
        groupTitle: i18nLocale("sideMenu.shop.concession"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/concession",
        permission: "Concession",
        props: { module: "concession" },
      },
      {
        name: "concessionCreate",
        component: () => import(/* webpackChunkName: "Concession" */ "@/pages/Concession/ConcessionAdd"),
        path: "/concession/create",
        props: { module: "concession" },
      },
      {
        name: "commercial",
        component: () => import(/* webpackChunkName: "Commercial" */ "@/pages/Commercial/Commercial"),
        accessRight: [ "cinema" ],
        groupTitle: i18nLocale("sideMenu.shop.commercial"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/commercial",
        permission: "Commerical",
        props: { module: "commercial" },
      },
      {
        name: "set",
        component: () => import(/* webpackChunkName: "Set" */ "@/pages/Set/Set"),
        accessRight: [ "cinema" ],
        groupTitle: i18nLocale("sideMenu.shop.set"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/set",
        permission: "Set",
        props: { module: "goods_package" },
      },
      {
        name: "ingredient",
        component: () => import(/* webpackChunkName: "Ingredient" */ "@/pages/Ingredient/Ingredient"),
        accessRight: [ "cinema" ],
        groupTitle: i18nLocale("sideMenu.shop.ingredient"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/ingredient",
        permission: "Ingredient list",
        props: { module: "ingredient" },
      },
      {
        name: "otherRevenue",
        component: () => import(/* webpackChunkName: "OtherRevenue" */ "@/pages/OtherRevenue/OtherRevenue"),
        accessRight: [ "cinema" ],
        groupTitle: i18nLocale("sideMenu.shop.otherRevenue"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/otherRevenue",
        permission: "Others Revenue",
        props: { module: "otherRevenue" },
      },
      {
        name: "otherGoods",
        component: () => import(/* webpackChunkName: "OtherGoods" */ "@/pages/OtherGoods/OtherGoods"),
        accessRight: [ "cinema" ],
        groupTitle: i18nLocale("sideMenu.shop.othersGroupSetting"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/otherGoods",
        permission: "Others Group setting",
        props: { module: "otherGoods" },
      },
      {
        name: "theaterDailyshow",
        component: () => import(/* webpackChunkName: "TheaterDailyShow" */ "@/pages/TheaterDailyShow"),
        accessRight: [ "cinema" ],
        groupTitle: i18nLocale("sideMenu.theaterDailyShow"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/theaterDailyshow",
        permission: "theaterDailyshow",
        props: { module: "theaterDailyshow" },
      },
    ],
  },
  {
    name: "couponLib",
    accessRight: ["brand", "cinema"],
    groupTitle: i18nLocale("sideMenu.couponLib"),
    icon: "el-icon-present",
    path: "",
    permission: "Coupon Library",
    item: [
      {
        name: "coupon",
        component: () => import(/* webpackChunkName: "Coupon" */ "@/pages/Coupon/Coupon"),
        accessRight: ["brand", "cinema"],
        groupTitle: i18nLocale("sideMenu.couponLib.coupon"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/coupon",
        permission: "Coupon",
        props: { module: "coupon" },
      },
      {
        name: "couponList",
        component: () => import(/* webpackChunkName: "CouponList" */ "@/pages/Coupon/CouponList"),
        path: "/couponlist/:id",
        props: { module: "coupon" },
      },
      // {
      //   name: "certification",
      //   component: () => import(/* webpackChunkName: "Certification" */ "@/pages/Coupon/Certification"),
      //   path: "/certification/:uuid/:couponName?",
      //   props: { module: "coupon" },
      // },
      {
        name: "ticket",
        component: () => import(/* webpackChunkName: "Ticket" */ "@/pages/Ticket/Ticket"),
        accessRight: ["brand", "cinema"],
        groupTitle: i18nLocale("sideMenu.couponLib.ticketVoucher"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/ticket",
        permission: "Ticket Voucher",
        props: { module: "advance_coupon" },
      },
      {
        name: "ticketList",
        component: () => import(/* webpackChunkName: "TicketList" */ "@/pages/Ticket/TicketList"),
        path: "/ticketlist/:id",
        props: { module: "advance_coupon" },
      },
    ],
  },
  {
    name: "operations",
    accessRight: ["brand", "cinema"],
    groupTitle: i18nLocale("sideMenu.operations"),
    icon: "el-icon-set-up",
    path: "",
    permission: "Operations",
    item: [
      {
        name: "nonArrivalTicketRecord",
        component: () => import(/* webpackChunkName: "NonArrivalTicket" */ "@/pages/Operations/NonArrivalTicket"),
        accessRight: [ "cinema" ],
        groupTitle: i18nLocale("sideMenu.operations.nonArrivalTicketRecord"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/non-arrival-ticket-record",
        permission: "未着券計上＋未着券売上計上履歴",
        props: { module: "" },
      },
      {
        name: "cashierReport",
        component: () => import(/* webpackChunkName: "CashierReport" */ "@/pages/Operation/CashierReport"),
        accessRight: [ "cinema" ],
        groupTitle: i18nLocale("sideMenu.operations.cashierReport"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/cashier-report",
        permission: "Cashier Report",
        props: { module: "" },
      },
      {
        name: "dailyClosing",
        component: () => import(/* webpackChunkName: "DailyClosing" */ "@/pages/Operations/DailyClosing"),
        accessRight: [ "cinema" ],
        groupTitle: i18nLocale("sideMenu.operations.dailyClosing"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/daily-closing",
        permission: "Daily Closing",
        props: { module: "" },
      },
      {
        name: "monthlyClosing",
        component: () => import(/* webpackChunkName: "MonthlyClosing" */ "@/pages/Operation/MonthlyClosing"),
        accessRight: ["cinema", "brand"],
        groupTitle: i18nLocale("sideMenu.operations.monthlyClosing"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/monthly-closing",
        permission: "Monthly Closing",
        props: { module: "" },
      },
    ],
  },
  {
    name: "reports",
    accessRight: ["superAdmin", "cinema", "brand"],
    groupTitle: i18nLocale("sideMenu.reports"),
    icon: "el-icon-notebook-1",
    path: "",
    permission: "Orders & Reports",
    item: [
      {
        name: "businessDaily",
        component: () => import(/* webpackChunkName: "BusinessDaily" */ "@/pages/Report/BusinessDaily"),
        accessRight: [ "cinema" ],
        groupTitle: i18nLocale("sideMenu.reports.businessDaily"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/business-daily",
        permission: "Daily Op. Report",
        props: { module: "business_report" },
      },
      {
        name: "businessDailyDetail",
        component: () => import(/* webpackChunkName: "BusinessDailyDetail" */ "@/pages/Report/BusinessDailyDetail"),
        accessRight: [ "cinema" ],
        groupTitle: i18nLocale("sideMenu.reports.businessDailyDetail"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/business-daily-detail",
        permission: "Daily Op. Report Detail",
        props: { module: "business_report_detail" },
      },
      {
        name: "soldRateDaily",
        component: () => import(/* webpackChunkName: "SoldRateDaily" */ "@/pages/Report/SoldRateDaily"),
        accessRight: [ "cinema" ],
        groupTitle: i18nLocale("sideMenu.reports.occupancy"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/sold-rate",
        permission: "Occupancy report",
        props: { module: "soldRate_report" },
      },
      {
        name: "boxOfficeDaily",
        component: () => import(/* webpackChunkName: "BoxOfficeDaily" */ "@/pages/Report/BoxOfficeDaily"),
        accessRight: [ "cinema" ],
        groupTitle: i18nLocale("sideMenu.reports.box"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/box-office-daily",
        permission: "Box Report",
        props: { module: "boxOffice_report" },
      },
      // {
      //   name: "boxOfficeSaleReport",
      //   component: () => import(/* webpackChunkName: "boxOfficeSaleReport" */ "@/pages/Report/boxOfficeSaleReport"),
      //   accessRight: [ "cinema" ],
      //   groupTitle: i18nLocale("sideMenu.reports.boxSaleReport"),
      //   icon: "egl-icon-custom-point egl-icon",
      //   path: "/box-office-sale-report",
      //   permission: "Box Sale Report",
      //   props: { module: "" },
      // },
      {
        name: "saleWeekly",
        component: () => import(/* webpackChunkName: "SaleWeekly" */ "@/pages/Report/SaleWeekly"),
        accessRight: [ "cinema" ],
        groupTitle: i18nLocale("sideMenu.reports.filmRevenueWeekly"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/sale-weekly",
        permission: "Film revenue weekly report",
        props: { module: "weekly_report" },
      },
      // {
      //   name: "totalRevenue",
      //   component: () => import(/* webpackChunkName: "Temporary" */ "@/pages/Temporary/Temporary"),
      //   accessRight: [ "cinema" ],
      //   groupTitle: i18nLocale("sideMenu.reports.totalRevenue"),
      //   icon: "egl-icon-custom-point egl-icon",
      //   path: "/total-revenue",
      //   permission: "Total revenue report",
      //   props: { module: "" },
      // },
      {
        name: "transactionHistory",
        component: () => import(/* webpackChunkName: "TransactionHistory" */ "@/pages/Report/TransactionHistory"),
        accessRight: [ "cinema" ],
        groupTitle: i18nLocale("sideMenu.reports.ticketTransaction"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/transaction-history",
        permission: "Ticket Transaction",
        props: { module: "ticket_report" },
      },
      {
        name: "transactionHistoryStand",
        component: () => import(/* webpackChunkName: "TransactionHistoryStand" */ "@/pages/Report/TransactionHistoryStand"),
        accessRight: [ "cinema" ],
        groupTitle: i18nLocale("sideMenu.reports.shopTransaction"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/transaction-history-stand",
        permission: "Other Transaction",
        props: { module: "goods_report" },
      },
      {
        name: "transactionCL",
        component: () => import(/* webpackChunkName: "TransactionHistoryCL" */ "@/pages/Report/TransactionHistoryCL"),
        accessRight: [ "brand" ],
        groupTitle: i18nLocale("sideMenu.reports.CLTransaction"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/transaction-history-cl",
        permission: "CL Transaction",
        props: { module: "cl_report" },
      },
      {
        name: "transactionHistoryOther",
        component: () => import(/* webpackChunkName: "TransactionHistoryOther" */ "@/pages/Report/TransactionHistoryOther"),
        accessRight: [ "cinema" ],
        groupTitle: i18nLocale("sideMenu.reports.otherTransaction"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/transaction-history-other",
        permission: "Shop Transaction",
        // props: { module: "goods_report" },
      },
      {
        name: "transactionLogTicket",
        component: () => import(/* webpackChunkName: "TransactionLog" */ "@/pages/Report/TransactionLog"),
        accessRight: [ "cinema" ],
        groupTitle: i18nLocale("sideMenu.reports.transactionLogTicket"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/transaction-log-ticket",
        permission: "Transaction log ticket",
        props: { module: "transactionLog_report" },
      },
      {
        name: "transactionLogShop",
        component: () => import(/* webpackChunkName: "TransactionLog" */ "@/pages/Report/TransactionLog"),
        accessRight: [ "cinema" ],
        groupTitle: i18nLocale("sideMenu.reports.transactionLogShop"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/transaction-log-shop",
        permission: "Transaction log shop",
        props: { module: "transactionLog_report" },
      },
      {
        name: "transactionLogOtherRevenue",
        component: () => import(/* webpackChunkName: "TransactionLog" */ "@/pages/Report/TransactionLog"),
        accessRight: [ "cinema" ],
        groupTitle: i18nLocale("sideMenu.reports.transactionLogOtherRevenue"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/transaction-log-other",
        permission: "Transaction log other",
        props: { module: "transactionLog_report" },
      },
      {
        name: "bookingDaily",
        component: () => import(/* webpackChunkName: "PreSalesDaily" */ "@/pages/Report/PreSalesDaily"),
        accessRight: [ "cinema" ],
        groupTitle: i18nLocale("sideMenu.reports.bookingDaily"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/booking-daily",
        permission: "booking daily report",
        props: { module: "" },
      },
      {
        name: "arriveDaily",
        component: () => import(/* webpackChunkName: "ArriveDaily" */ "@/pages/Report/ArriveDaily"),
        accessRight: [ "cinema" ],
        groupTitle: i18nLocale("sideMenu.reports.arriveDaily"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/arrive-daily",
        permission: "arrive daily report",
        props: { module: "" },
      },
      {
        name: "onlineBooking",
        component: () => import(/* webpackChunkName: "OnlineBooking" */ "@/pages/Report/OnlineBooking"),
        accessRight: ["superAdmin", "cinema"],
        groupTitle: i18nLocale("sideMenu.reports.onlineBooking"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/online-booking",
        permission: "Online booking report",
        props: { module: "" },
      },
      {
        name: "filmFee",
        component: () => import(/* webpackChunkName: "FilmFee" */ "@/pages/Report/FilmFee"),
        accessRight: [ "cinema" ],
        groupTitle: i18nLocale("sideMenu.reports.ticketSharing"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/film-fee",
        permission: "Ticket Sharing",
        props: { module: "filmFee_report" },
      },
      {
        name: "inventoryAdjustment",
        component: () => import(/* webpackChunkName: "InventoryAdjustmentLog" */ "@/pages/Report/InventoryAdjustmentLog"),
        accessRight: [ "cinema" ],
        groupTitle: i18nLocale("sideMenu.reports.inventoryLog"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/inventory-adjustment",
        permission: "inventoryLog",
        props: { module: "stock_report" },
      },
      {
        name: "inventory",
        component: () => import(/* webpackChunkName: "Inventory" */ "@/pages/Report/Inventory"),
        accessRight: [ "cinema" ],
        groupTitle: i18nLocale("sideMenu.reports.inventory"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/inventory",
        permission: "inventory",
        props: { module: "inventoryLog" },
      },
      {
        name: "revenueGoal",
        component: () => import(/* webpackChunkName: "RevenueGoal" */ "@/pages/Report/RevenueGoal"),
        accessRight: [ "cinema" ],
        groupTitle: i18nLocale("sideMenu.reports.revenueGoal"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/revenue-goal",
        permission: "RevenueGoal",
        props: { module: "salesGoal_report" },
      },
      {
        name: "shopSales",
        component: () => import(/* webpackChunkName: "RevenueGoal" */ "@/pages/Report/ShopSale"),
        accessRight: [ "cinema" ],
        groupTitle: i18nLocale("sideMenu.reports.shopSale"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/shop-sale",
        permission: "shopSales_report",
        props: { module: "shopSales_report" },
      },
      {
        name: "pdfAccountReceivableBalanceDetail",
        component: () => import(/* webpackChunkName: "pdfAccountReceivableBalanceDetail" */ "@/pages/Report/pdfAccountReceivableBalanceDetail"),
        accessRight: ["cinema", "brand"],
        groupTitle: i18nLocale("sideMenu.reports.pdfAccountReceivableBalanceDetail"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/pdf-account-receivable-balance-detail",
        permission: "Pdf Account Receivable Balance Detail",
        props: { module: "" },
      },
      {
        name: "pdfAccountsReceivableBalance",
        component: () => import(/* webpackChunkName: "PdfAccountsReceivableBalance" */ "@/pages/Report/PdfAccountsReceivableBalance"),
        accessRight: ["cinema", "brand"],
        groupTitle: i18nLocale("sideMenu.reports.pdfAccountsReceivableBalance"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/pdf-accounts-receivable-balance",
        permission: "pdfAccountsReceivableBalance",
        props: { module: "" },
      },
      {
        name: "pdfFilmFeeBalance",
        component: () => import(/* webpackChunkName: "PdfFilmFeeBalance" */ "@/pages/Report/PdfFilmFeeBalance"),
        accessRight: ["cinema", "brand"],
        groupTitle: i18nLocale("sideMenu.reports.pdfFilmFeeBalance"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/pdf-film-fee-balance",
        permission: "Pdf Film Fee Balance",
        props: { module: "" },
      },
      {
        name: "accountsReceivableVerify",
        component: () => import(/* webpackChunkName: "PdfAccountsReceivableVerify" */ "@/pages/Report/PdfAccountsReceivableVerify"),
        accessRight: ["cinema", "brand"],
        groupTitle: i18nLocale("sideMenu.reports.accountsReceivableVerify"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/pdf-accounts-receivable-verify",
        permission: "Accounts Receivable Verify",
        props: { module: "" },
      },
      {
        name: "pdfFilmFee",
        component: () => import(/* webpackChunkName: "PdfFilmFee" */ "@/pages/Report/PdfFilmFee"),
        accessRight: ["cinema", "brand"],
        groupTitle: i18nLocale("sideMenu.reports.pdfFilmFee"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/pdf-film-fee",
        permission: "Pdf Film Fee",
        props: { module: "" },
      },
      {
        name: "ticketSales",
        component: () => import(/* webpackChunkName: "TicketSales" */ "@/pages/Report/TicketSales"),
        accessRight: [ "cinema" ],
        groupTitle: i18nLocale("sideMenu.reports.ticketSales"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/ticket-sales",
        permission: "Ticket Sales",
      },
      {
        name: "accumulated",
        component: () => import(/* webpackChunkName: "PdfFilmFee" */ "@/pages/Report/Accumulated"),
        accessRight: [ "cinema" ],
        groupTitle: i18nLocale("sideMenu.reports.accumulated"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/accumulated",
        permission: "accumulated",
        props: { module: "" },
      },
      {
        name: "memberShip",
        component: () => import(/* webpackChunkName: "MemberShipReport" */ "@/pages/Report/MemberShip"),
        accessRight: [ "brand" ],
        groupTitle: i18nLocale("report.memberShip"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/memberShip-report",
        permission: "MemberShip Report"
      },
      {
        name: "memberShipFeeSales",
        component: () => import(/* webpackChunkName: "MemberShipFeeSalesReport" */ "@/pages/Report/MemberShipFeeSales"),
        accessRight: ["brand", "cinema"],
        groupTitle: i18nLocale("report.memberShipFeeSales"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/memberShip-feeSales-report",
        permission: "MemberShipFeeSales Report"
      },
      {
        name: "memberShipOnlineFeeSales",
        component: () => import(/* webpackChunkName: "MemberShipOnlineFeeSalesReport" */ "@/pages/Report/MemberShipOnlineFeeSales"),
        accessRight: [ "brand" ],
        groupTitle: i18nLocale("report.memberShipOnlineFeeSales"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/memberShip-onlineFeeSales-report",
        permission: "MemberOnlineShipFeeSales Report"
      },
      {
        name: "onlineReservationSalesReport",
        component: () => import(/* webpackChunkName: "OnlineReservationSalesReport" */ "@/pages/Report/OnlineReservationSalesReport"),
        accessRight: [ "superAdmin" ],
        groupTitle: i18nLocale("sideMenu.onlineReservationSalesReport"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/onlineReservationSalesReport",
        permission: "OnlineReservationSales Report"
      },
      {
        name: "membershipFeeSalesReport",
        component: () => import(/* webpackChunkName: "MembershipFeeSalesReport" */ "@/pages/Report/MembershipFeeSalesReport"),
        accessRight: [ "superAdmin" ],
        groupTitle: "会員会費 決済サマリー",
        icon: "egl-icon-custom-point egl-icon",
        path: "/membershipFeeSalesReport",
        permission: "MembershipFeeSales Report"
      }
    ],
  },
  {
    name: "screenList",
    component: () => import(/* webpackChunkName: "Theatre" */ "@/pages/Theatre/Theatre"),
    accessRight: [ "cinema" ],
    groupTitle: i18nLocale("sideMenu.screen"),
    icon: "icon-screen",
    path: "/house",
    permission: "Screen",
    props: { module: "theatre" },
    item: [],
  },
  {
    name: "signage",
    component: () => import(/* webpackChunkName: "Signage" */ "@/pages/Signage/Signage"),
    accessRight: [ "cinema" ],
    groupTitle: i18nLocale("sideMenu.signage"),
    icon: "icon-signage",
    path: "/signage",
    permission: "Signage",
    props: { module: "Signage" },
    item: [],
  },
  {
    name: "customDisplay",
    component: () => import(/* webpackChunkName: "Device" */ "@/pages/CustomDisplay/CustomDisplay"),
    accessRight: [ "cinema" ],
    groupTitle: i18nLocale("setting.customDisplay.title"),
    icon: "icon-customDisplay",
    path: "/custom-display",
    permission: "Custom Display",
    props: { module: "custom_display" },
    item: [],
  },
  {
    name: "ticket customization",
    accessRight: [ "cinema" ],
    groupTitle: i18nLocale("sideMenu.ticketCustomization"),
    icon: "icon-ticket",
    permission: "ticketCustomization",
    props: { module: "ticketCustomization" },
    item: [
      {
        name: "customized message",
        component: () => import(/* webpackChunkName: "customizedMessage" */ "@/pages/TicketCustomization/CustomizedMessage"),
        accessRight: [ "cinema" ],
        groupTitle: i18nLocale("sideMenu.customizedMessage"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/customized-message",
        permission: "customizedMessage",
        props: { module: "customizedMessage" },
      },
    ],
  },
  {
    name: "screenCreate",
    component: () => import(/* webpackChunkName: "TheatreDetail" */ "@/pages/Theatre/TheatreDetail"),
    accessRight: ["brand", "cinema"],
    path: "/house/create",
    props: { module: "theatre" },
  },
  {
    name: "screenUpdate",
    component: () => import(/* webpackChunkName: "TheatreDetail" */ "@/pages/Theatre/TheatreDetail"),
    accessRight: ["brand", "cinema"],
    path: "/house/update/:id",
    props: { module: "theatre" },
  },
  {
    name: "scheduleScreenUpdate",
    component: () => import(/* webpackChunkName: "TheatreDetail" */ "@/pages/Theatre/TheatreDetail"),
    accessRight: ["brand", "cinema"],
    path: "/house/schedule-update/:id",
    props: { module: "theatre" },
  },
  {
    name: "settings",
    accessRight: ["superAdmin", "brand", "cinema"],
    groupTitle: i18nLocale("sideMenu.settings"),
    icon: "el-icon-setting",
    path: "",
    permission: "Settings",
    item: [
      {
        name: "brand",
        component: () => import(/* webpackChunkName: "Brand" */ "@/pages/Brand/Brand"),
        accessRight: ["superAdmin", "brand"],
        groupTitle: i18nLocale("sideMenu.settings.brandManagement"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/brand",
        permission: "Brand Management",
        props: { module: "brand" },
      },
      {
        name: "brandCreate",
        component: () => import(/* webpackChunkName: "BrandDetail" */ "@/pages/Brand/BrandDetail"),
        path: "/brand/create",
        props: { module: "brand" },
      },
      {
        name: "brandEdit",
        component: () => import(/* webpackChunkName: "BrandDetail" */ "@/pages/Brand/BrandDetail"),
        path: "/brand/edit/:id",
        props: { module: "brand" },
      },
      {
        name: "cinema",
        component: () => import(/* webpackChunkName: "Cinema" */ "@/pages/Cinema/Cinema"),
        accessRight: ["brand", "cinema"],
        groupTitle: i18nLocale("sideMenu.settings.cinemaManagement"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/cinema",
        permission: "Cinema Management",
        props: { module: "cinema" },
      },
      {
        name: "cinemaCreate",
        component: () => import(/* webpackChunkName: "CinemaDetail" */ "@/pages/Cinema/CinemaDetail"),
        path: "/cinema/create",
        props: { module: "cinema" },
      },
      {
        name: "cinemaUpdate",
        component: () => import(/* webpackChunkName: "CinemaDetail" */ "@/pages/Cinema/CinemaDetail"),
        path: "/cinema/update/:id",
        props: { module: "cinema" },
      },
      {
        name: "globalSetting",
        component: () => import(/* webpackChunkName: "Global" */ "@/pages/Setting/Global"),
        accessRight: [ "superAdmin" ],
        groupTitle: i18nLocale("sideMenu.settings.global"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/setting-global",
        permission: "Global Setting",
        props: { module: "global_setting" },
      },
      {
        name: "paymentManagement",
        component: () => import(/* webpackChunkName: "Payment" */ "@/pages/Setting/Payment"),
        accessRight: [ "cinema" ],
        groupTitle: i18nLocale("sideMenu.settings.payment"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/payment-management",
        permission: "Payment Setting",
        props: { module: "payment" },
      },
      {
        name: "device",
        component: () => import(/* webpackChunkName: "Device" */ "@/pages/Device/Device"),
        accessRight: [ "cinema" ],
        groupTitle: i18nLocale("sideMenu.settings.devices"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/device",
        permission: "Devices Setting",
        props: { module: "device_setting" },
      },
      {
        name: "kitchenPrinterDevice",
        component: () => import(/* webpackChunkName: "Device" */ "@/pages/kitchenPrinterDevice"),
        accessRight: [ "cinema" ],
        groupTitle: i18nLocale("setting.kitchenPrinterDevice.title"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/kitchen-printer-device",
        permission: "Kitchen Printer Device",
        props: { module: "kiten_printer_device" },
      },
      {
        name: "onlineSaleSetting",
        component: () => import(/* webpackChunkName: "OnlineSale" */ "@/pages/Setting/OnlineSale"),
        accessRight: ["superAdmin", "cinema"],
        groupTitle: i18nLocale("sideMenu.settings.disableOnlineBooking"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/setting-onlinesale",
        permission: "Disable online booking",
        props: { module: "stopOnlineTicketing_setting" },
      },
      {
        name: "superAdminDevice",
        component: () => import(/* webpackChunkName: "superAdminDevice" */ "@/views/device/SuperAdminDeviceList.vue"),
        accessRight: [ "superAdmin" ],
        groupTitle: i18nLocale("sideMenu.settings.devicesManagement"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/super-admin/device",
        permission: "Device Management",
        props: { module: "device_setting" },
        item: [],
      }
    ],
  },
  {
    name: "clientManagement",
    accessRight: ["brand", "cinema"],
    groupTitle: i18nLocale("sideMenu.clientManagement"),
    icon: "el-icon-wallet",
    path: "",
    permission: "Client Management",
    item: [
      {
        name: "deposit",
        component: () => import(/* webpackChunkName: "Deposit" */ "@/pages/Deposit/Deposit"),
        accessRight: ["brand", "cinema"],
        groupTitle: i18nLocale("sideMenu.clientManagement.deposit"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/deposit",
        permission: "Bank Account",
        props: { module: "bankAccount" },
      },
      {
        name: "clientGroup",
        component: () => import(/* webpackChunkName: "ClientGroup" */ "@/pages/Client/ClientGroup"),
        accessRight: ["brand", "cinema"],
        groupTitle: i18nLocale("sideMenu.clientManagement.clientGroup"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/client-group",
        permission: "Client Group",
        props: { module: "client_group" },
      },
      {
        name: "client",
        component: () => import(/* webpackChunkName: "Client" */ "@/pages/Client/Client"),
        accessRight: ["brand", "cinema"],
        groupTitle: i18nLocale("sideMenu.clientManagement.client"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/client",
        permission: "Client",
        props: { module: "client" },
      }
    ],
  },
  {
    name: "users",
    accessRight: ["superAdmin", "brand", "cinema"],
    groupTitle: i18nLocale("sideMenu.users"),
    icon: "el-icon-user",
    path: "",
    permission: "Users",
    item: [
      {
        name: "userList",
        component: () => import(/* webpackChunkName: "User" */ "@/pages/User/User"),
        accessRight: ["superAdmin", "brand", "cinema"],
        groupTitle: i18nLocale("sideMenu.users.userManagement"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/user",
        permission: "User Management",
        props: { module: "account" },
      },
      {
        name: "userCreate",
        component: () => import(/* webpackChunkName: "UserDetail" */ "@/pages/User/UserDetail"),
        path: "/user/create",
        props: { module: "account" },
      },
      {
        name: "userEdit",
        component: () => import(/* webpackChunkName: "UserDetail" */ "@/pages/User/UserDetail"),
        path: "/user/edit/:id",
        props: { module: "account" },
      },
      {
        name: "userDetail",
        component: () => import(/* webpackChunkName: "UserDetail" */ "@/pages/User/UserDetail"),
        path: "/user/detail/:id",
        props: { module: "account" },
      },
      {
        name: "roleList",
        component: () => import(/* webpackChunkName: "Role" */ "@/pages/Role/Role"),
        accessRight: ["superAdmin", "brand", "cinema"],
        groupTitle: i18nLocale("sideMenu.users.roleManagement"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/role",
        permission: "Role Management",
        props: { module: "role" },
      },
      {
        name: "roleCreate",
        component: () => import(/* webpackChunkName: "RoleDetail" */ "@/pages/Role/RoleDetail"),
        path: "/role/create",
        props: { module: "role" },
      },
      {
        name: "roleEdit",
        component: () => import(/* webpackChunkName: "RoleDetail" */ "@/pages/Role/RoleDetail"),
        path: "/role/edit/:id",
        props: { module: "role" },
      },
      {
        name: "roleDetail",
        component: () => import(/* webpackChunkName: "RoleDetail" */ "@/pages/Role/RoleDetail"),
        path: "/role/detail/:id",
        props: { module: "role" },
      },
      {
        name: "accountSetting",
        component: () => import(/* webpackChunkName: "Account" */ "@/pages/Setting/Account"),
        accessRight: ["brand", "cinema"],
        groupTitle: i18nLocale("sideMenu.users.accountSetting"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/setting-account",
        permission: "Account Setting",
        props: { module: "account_setting" },
      }
    ],
  },
  // Cinema Website
  {
    name: "cinemaWebsite",
    accessRight: [ "cinema" ],
    groupTitle: i18nLocale("sideMenu.cinemaWebsite"),
    icon: "icon-cinemaWebsite",
    path: "",
    permission: "Cinema WebSite",
    item: [
      {
        name: "news",
        component: () => import(/* webpackChunkName: "News" */ "@/pages/CinemaWebsite/News/News"),
        accessRight: [ "cinema" ],
        groupTitle: i18nLocale("sideMenu.cinemaWebsite.news"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/news",
        permission: "Cinema WebSite",
        props: { module: "website" },
      },
      {
        name: "newsCreate",
        component: () => import(/* webpackChunkName: "NewsDetail" */ "@/pages/CinemaWebsite/News/NewsDetail"),
        accessRight: [ "cinema" ],
        path: "/news/create",
        permission: "News create",
        props: { module: "website" },
      },
      {
        name: "newsUpdate",
        component: () => import(/* webpackChunkName: "NewsDetail" */ "@/pages/CinemaWebsite/News/NewsDetail"),
        accessRight: [ "cinema" ],
        path: "/news/update/:id",
        permission: "News edit",
        props: { module: "website" },
      },
      {
        name: "custom",
        component: () => import(/* webpackChunkName: "Custom" */ "@/pages/CinemaWebsite/Custom/Custom"),
        accessRight: [ "cinema" ],
        groupTitle: i18nLocale("sideMenu.cinemaWebsite.custom"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/custom",
        permission: "Cinema WebSite",
        props: { module: "website" },
      },
      {
        name: "customCreate",
        component: () => import(/* webpackChunkName: "CustomDetail" */ "@/pages/CinemaWebsite/Custom/CustomDetail"),
        accessRight: [ "cinema" ],
        path: "/custom/create",
        permission: "Custom create",
        props: { module: "website" },
      },
      {
        name: "customUpdate",
        component: () => import(/* webpackChunkName: "CustomDetail" */ "@/pages/CinemaWebsite/Custom/CustomDetail"),
        accessRight: [ "cinema" ],
        path: "/custom/update/:id",
        permission: "Custom edit",
        props: { module: "website" },
      },
      {
        name: "priceTable",
        component: () => import(/* webpackChunkName: "PriceTable" */ "@/pages/CinemaWebsite/PriceTable/PriceTable"),
        accessRight: [ "cinema" ],
        groupTitle: i18nLocale("sideMenu.cinemaWebsite.priceTable"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/priceTable",
        permission: "Cinema WebSite",
        props: { module: "website" },
      },
      {
        name: "priceTableCreate",
        component: () => import(/* webpackChunkName: "PriceTableDetail" */ "@/pages/CinemaWebsite/PriceTable/PriceTableDetail"),
        accessRight: [ "cinema" ],
        path: "/priceTable/create",
        permission: "Cinema WebSite",
        props: { module: "website" },
      },
      {
        name: "priceTableUpdate",
        component: () => import(/* webpackChunkName: "PriceTableDetail" */ "@/pages/CinemaWebsite/PriceTable/PriceTableDetail"),
        accessRight: [ "cinema" ],
        path: "/priceTable/update/:id",
        permission: "Cinema WebSite",
        props: { module: "website" },
      },
      {
        name: "admissionInfo",
        component: () => import(/* webpackChunkName: "WebsiteGuideSetting" */ "@/pages/CinemaWebsite/WebsiteGuideSetting/WebsiteGuideSetting"),
        accessRight: [ "cinema" ],
        groupTitle: i18nLocale("sideMenu.cinemaWebsite.admissionInfo"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/admissionInfo",
        permission: "Cinema WebSite",
        props: { module: "website" },
      },
      {
        name: "notice",
        component: () => import(/* webpackChunkName: "WebsiteGuideSetting" */ "@/pages/CinemaWebsite/WebsiteGuideSetting/WebsiteGuideSetting"),
        accessRight: [ "cinema" ],
        groupTitle: i18nLocale("sideMenu.cinemaWebsite.notice"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/notice",
        permission: "Cinema WebSite",
        props: { module: "website" },
      },
      {
        name: "commonProblems",
        component: () => import(/* webpackChunkName: "WebsiteGuideSetting" */ "@/pages/CinemaWebsite/WebsiteGuideSetting/WebsiteGuideSetting"),
        accessRight: [ "cinema" ],
        groupTitle: i18nLocale("sideMenu.cinemaWebsite.commonProblems"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/commonProblems",
        permission: "Cinema WebSite",
        props: { module: "website" },
      },
      {
        name: "rentalSpace",
        component: () => import(/* webpackChunkName: "WebsiteGuideSetting" */ "@/pages/CinemaWebsite/RentalSpace/RentalSpace"),
        accessRight: [ "cinema" ],
        groupTitle: i18nLocale("sideMenu.cinemaWebsite.rentalSpace"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/rentalSpace",
        permission: "Cinema WebSite",
        props: { module: "website" },
      },
      {
        name: "privacyPolicy",
        component: () => import(/* webpackChunkName: "WebsiteGuideSetting" */ "@/pages/CinemaWebsite/WebsiteGuideSetting/WebsiteGuideSetting"),
        accessRight: [ "cinema" ],
        groupTitle: i18nLocale("sideMenu.cinemaWebsite.privacyPolicy"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/privacyPolicy",
        permission: "Cinema WebSite",
        props: { module: "website" },
      },
      {
        name: "serviceTerms",
        component: () => import(/* webpackChunkName: "WebsiteGuideSetting" */ "@/pages/CinemaWebsite/WebsiteGuideSetting/WebsiteGuideSetting"),
        accessRight: [ "cinema" ],
        groupTitle: i18nLocale("sideMenu.cinemaWebsite.serviceTerms"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/serviceTerms",
        permission: "Cinema WebSite",
        props: { module: "website" },
      },
      {
        name: "serviceTermsRemark",
        component: () => import(/* webpackChunkName: "WebsiteGuideSetting" */ "@/pages/CinemaWebsite/WebsiteGuideSetting/WebsiteGuideSetting"),
        accessRight: [ "cinema" ],
        groupTitle: i18nLocale("sideMenu.cinemaWebsite.serviceTermsRemark"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/serviceTermsRemark",
        permission: "Cinema WebSite",
        props: { module: "website" },
      },
      {
        name: "websiteSetting",
        component: () => import(/* webpackChunkName: "WebsiteSetting" */ "@/pages/CinemaWebsite/WebsiteSetting/WebsiteSetting"),
        accessRight: [ "cinema" ],
        groupTitle: i18nLocale("sideMenu.cinemaWebsite.websiteSetting"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/websiteSetting",
        permission: "Cinema WebSite",
        props: { module: "website" },
      },
      {
        name: "colorStyleSetting",
        component: () => import(/* webpackChunkName: "ColorStyleSetting" */ "@/pages/CinemaWebsite/ColorStyleSetting/ColorStyleSetting"),
        accessRight: [ "cinema" ],
        groupTitle: i18nLocale("sideMenu.cinemaWebsite.colorStyleSetting"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/colorStyleSetting",
        permission: "Cinema WebSite",
        props: { module: "website" },
      },
      {
        name: "websiteInformation",
        component: () => import(/* webpackChunkName: "websiteInformation" */ "@/pages/CinemaWebsite/WebsiteInformation/WebsiteInformation"),
        accessRight: [ "cinema" ],
        groupTitle: i18nLocale("cinemaWebsite.websiteSetting.formItem.websiteInformation"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/websiteInformation",
        permission: "Cinema WebSite",
        props: { module: "website" },
      },
      {
        name: "companyInfo",
        component: () => import(/* webpackChunkName: "companyInfo" */ "@/pages/CinemaWebsite/CompanyInfo/CompanyInfo"),
        accessRight: [ "cinema" ],
        groupTitle: i18nLocale("sideMenu.cinemaWebsite.companyInfo"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/companyInfo",
        permission: "Cinema WebSite",
        props: { module: "website" },
      },
    ]
  },
  // Cinema Schedule
  {
    name: "cinemaSchedule",
    component: () => import(/* webpackChunkName: "Theatre" */ "@/pages/CinemaSchedule/CinemaSchedule"),
    accessRight: [ "cinema" ],
    groupTitle: i18nLocale("sideMenu.cinemaSchedule"),
    icon: "icon-cinemaSchedule",
    path: "/cinema-schedule",
    permission: "Cinema WebSite",
    item: []
  },
  {
    name: "accounting",
    accessRight: [ "brand" ],
    groupTitle: i18nLocale("sideMenu.accounting"),
    icon: "el-icon-data-line",
    path: "",
    permission: "Accounting",
    item: [
      {
        name: "accounting",
        component: () => import(/* webpackChunkName: "AccountingManagement" */ "@/pages/Accounting/AccountingManagement"),
        accessRight: [ "brand" ],
        groupTitle: i18nLocale("sideMenu.accounting.management"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/accounting-management",
        permission: "勘定科目管理",
        props: { module: "accountingManagement" },
      },
      {
        name: "AccountPayable",
        component: () => import(/* webpackChunkName: "AccountPayable" */ "@/pages/AccountPayable/AccountPayable"),
        accessRight: [ "brand" ],
        groupTitle: i18nLocale("sideMenu.accountPayable.management"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/account-payable",
        permission: "AccountPayable",
        props: { module: "account_payable" },
      },
      {
        name: "AccountReceivable",
        component: () => import(/* webpackChunkName: "AccountReceivable" */ "@/pages/AccountReceivable/AccountReceivable"),
        accessRight: [ "brand" ],
        groupTitle: i18nLocale("sideMenu.accountReceivable.management"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/account-receivable",
        permission: "accountReceivable",
        props: { module: "accountReceivable" },
      },
      {
        name: "SalesGroupManagement",
        component: () => import(/* webpackChunkName: "SalesGroupManagement" */ "@/pages/SalesGroup/SalesGroupManagement"),
        accessRight: [ "brand" ],
        groupTitle: i18nLocale("sideMenu.salesGroupManagement"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/salesGroup-management",
        permission: "salesGroup-management",
        props: { module: "salesGroup-management" },
      },
    ]
  },
  {
    name: "TTCG",
    accessRight: ["cinema", "brand"],
    groupTitle: "TTCG",
    icon: "el-icon-files egl-icon",
    path: "",
    permission: "TTCG",
    props: { module: "" },
    specialForUser: ["TTCG", "ECB", "DEMO", "K-TTCG", "TESTING-1001"],
    item: [
      {
        name: "cinemaDaily",
        component: () => import(/* webpackChunkName: "CinemaDaily" */ "@/pages/Report/CinemaDaily"),
        accessRight: ["cinema", "brand"],
        groupTitle: i18nLocale("sideMenu.reports.cinemaDaily"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/cinema-daily",
        permission: "cinemaDaily",
        props: { module: "" },
      },
      {
        name: "boxOfficeSaleReport",
        component: () => import(/* webpackChunkName: "boxOfficeSaleReport" */ "@/pages/Report/boxOfficeSaleReport"),
        accessRight: [ "cinema" ],
        groupTitle: i18nLocale("sideMenu.reports.boxSaleReport"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/box-office-sale-report",
        permission: "Box Sale Report",
        props: { module: "" },
      },
      {
        name: "CLIkebukuroCusReport",
        component: () => import(/* webpackChunkName: "CLIkebukuroCusReport" */ "@/pages/Report/CLIkebukuroCusReport"),
        accessRight: ["cinema", "brand"],
        groupTitle: `${i18nLocale("sideMenu.reports.CLIkebukuro")}(${i18nLocale("CL.breakDownSales")})`,
        icon: "egl-icon-custom-point egl-icon",
        path: "/CL-ikebukuro-cus-report",
        permission: "CLIkebukuroCusReport",
        props: { module: "" },
      },
      {
        name: "CLshopSaleDetailReport",
        component: () => import(/* webpackChunkName: "CLIkebukuroCusReport" */ "@/pages/Report/CLshopSaleDetailReport"),
        accessRight: ["cinema", "brand"],
        groupTitle: `${i18nLocale("sideMenu.reports.CLIkebukuro")}(${i18nLocale("CL.incidentalTable")})`,
        icon: "egl-icon-custom-point egl-icon",
        path: "/CL-shopSale-detail-report",
        permission: "CLshopSaleDetailReport",
        props: { module: "" },
      },
      {
        name: "AccountingReportDownload",
        component: () => import(/* webpackChunkName: "AccountingReportDownload" */ "@/pages/AccountingReportDownload/AccountingReportDownload"),
        accessRight: [ "brand" ],
        groupTitle: i18nLocale("sideMenu.accountingReportDownload"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/accounting-report-download",
        permission: "accounting-report-download",
        props: { module: "accounting-report-download" },
      }
    ],
  },
  {
    name: "dailyBusinessUpdate",
    component: () => import(/* webpackChunkName: "dailyBusinessUpdate" */ "@/pages/DailyBusinessUpdate/DailyBusinessUpdate"),
    accessRight: [ "brand" ],
    groupTitle: i18nLocale("sideMenu.businessDailyUpdate"),
    icon: "el-icon-document-copy egl-icon",
    path: "/dailyBusiness-update",
    permission: "dailyBusiness-update",
    props: { module: "" },
    item: [],
  },
  {
    name: "domainEdit",
    component: () => import(/* webpackChunkName: "editDomain" */ "@/pages/EditDomain/editDomain.vue"),
    accessRight: [ "superAdmin" ],
    groupTitle: "edit-domain",
    icon: "el-icon-document-copy egl-icon",
    path: "/edit-domain",
    permission: "edit-domain",
    props: { module: "" },
    item: [],
  },
  {
    name: "memberShip",
    accessRight: [ "brand" ],
    groupTitle: i18nLocale("sideMenu.memberShip"),
    icon: "icon-memberShip",
    path: "",
    permission: "Member Ship",
    item: [
      {
        name: "memberShip-list",
        component: () => import(/* webpackChunkName: "MemberShip" */ "@/pages/MemberShip/MemberShipList"),
        accessRight: [ "brand" ],
        groupTitle: i18nLocale("sideMenu.memberShip.list"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/memberShip-list",
        permission: "memberShip-list",
        props: { module: "memberShip-list" },
      },
      {
        name: "memberShip-list-create",
        component: () => import(/* webpackChunkName: "MemberShipDetail" */ "@/pages/MemberShip/MemberShipListDetail"),
        accessRight: ["brand"],
        path: "/memberShip-list/create",
        permission: "memberShip list create",
        props: { module: "memberShip-list-create" },
      },
      {
        name: "memberShip-list-update",
        component: () => import(/* webpackChunkName: "MemberShipDetail" */ "@/pages/MemberShip/MemberShipListDetail"),
        accessRight: ["brand"],
        path: "/memberShip-list/update/:id",
        permission: "memberShip list update",
        props: { module: "memberShip-list-update" },
      },
      {
        name: "memberAgeGroup",
        component: () => import(/* webpackChunkName: "MemberAgeGroup" */ "@/pages/Brand/MemberAgeGroup"),
        accessRight: ["brand"],
        groupTitle: i18nLocale("sideMenu.settings.memberAgeGroup"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/member-age-group",
        permission: "memberShip-list",
        props: { module: "member-age-group" },
      },
      {
        name: "member-list",
        component: () => import(/* webpackChunkName: "MemberList" */ "@/pages/MemberShip/MemberList"),
        accessRight: [ "brand" ],
        groupTitle: i18nLocale("sideMenu.memberList"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/member-list",
        permission: "member-list",
        props: { module: "member-list" },
      },
      {
        name: "coupon-list",
        component: () => import(/* webpackChunkName: "MemberCouponList" */ "@/pages/MemberShip/CouponList"),
        accessRight: [ "brand" ],
        groupTitle: i18nLocale("couponList.sideMenu"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/coupon-list",
        permission: "coupon-list",
        props: { module: "coupon-list" },
      },
      {
        name: "enduser-customizePage",
        component: () => import(/* webpackChunkName: "EndUserPage" */ "@/pages/MemberShip/enduserCustomizePage"),
        accessRight: [ "brand" ],
        groupTitle: i18nLocale("endUserCustomizePage.sideMenu"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/endUser-customizePage",
        permission: "endUser CustomizePage",
        props: { module: "endUser-CustomizePage" },
      },
      {
        name: "automation-rule",
        component: () => import(/* webpackChunkName: "AutomationRule" */ "@/pages/MemberShip/AutoMationRule"),
        accessRight: [ "brand" ],
        groupTitle: i18nLocale("sideMenu.automationRule"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/automation-rule",
        permission: "automation rule",
        props: { module: "automation-rule" },
      },
      {
        name: "mail-magazine-list",
        component: () => import(/* webpackChunkName: "mailMagazineList" */ "@/pages/MemberShip/MailMagazine"),
        accessRight: [ "brand" ],
        groupTitle: i18nLocale("mail.list.title"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/mail-magazine",
        permission: "mail magazine list",
        props: { module: "mail-magazine-list" },
      },
      {
        name: "mail-magazine-create",
        component: () => import(/* webpackChunkName: "mailMagazineCreate" */ "@/pages/MemberShip/MailMagazine/detail"),
        accessRight: [ "brand" ],
        path: "/mail-magazine/create",
        permission: "mail magazine create",
        props: { module: "mail-magazine-create" },
      },
      {
        name: "mail-magazine-update",
        component: () => import(/* webpackChunkName: "mailMagazineUpdate" */ "@/pages/MemberShip/MailMagazine/detail"),
        accessRight: [ "brand" ],
        path: "/mail-magazine/update/:id",
        permission: "mail magazine update",
        props: { module: "mail-magazine-update" },
      },
      {
        name: "member-filter",
        component: () => import(/* webpackChunkName: "memberFilter" */ "@/pages/MemberShip/MemberFilter"),
        accessRight: [ "brand" ],
        groupTitle: i18nLocale("sidemenu.memberFilter.title"),
        icon: "egl-icon-custom-point egl-icon",
        path: "/member-filter",
        permission: "member filter list",
        props: { module: "member-filter-list" },
      },
      {
        name: "member-filter-create",
        component: () => import(/* webpackChunkName: "memberFilterCreate" */ "@/pages/MemberShip/MemberFilter/detail"),
        accessRight: [ "brand" ],
        path: "/member-filter/create",
        permission: "member filter create",
        props: { module: "member-filter-create" },
      },
      {
        name: "member-filter-update",
        component: () => import(/* webpackChunkName: "memberFilterUpdate" */ "@/pages/MemberShip/MemberFilter/detail"),
        accessRight: [ "brand" ],
        path: "/member-filter/update/:id",
        permission: "member filter update",
        props: { module: "member-filter-update" },
      },
    ]
  },
];

export default menuMapping;
